import { PauseMassiveContext, RemoveMassiveContext } from '@/context/Context';
import {
  useDeleteMassiveHistoryMutation,
  useStopMassiveProgressMutation
} from '@/app/KeywordResearch/api/massiveApi';
import React, { useContext } from 'react';
import CancelModal from '@/app/common/components/CancelModal';
import { errorMessage, successMessage, warningMessage } from '@/utils/toast';
import { Modal } from '@/components/common/AppModal';
import { Spinner } from 'react-bootstrap';
import { useGetUserInfoQuery } from '@/app/common/api/authApi';

const MassiveProviders = ({ children }) => {
  const {
    delayModal,
    setDelayModal,
    setShowStopModal,
    showStopModal,
    task_id: pauseTaskId
  } = useContext(PauseMassiveContext);
  const { data: userInfo } = useGetUserInfoQuery();

  const { keyword, setShow, show, task_id } = useContext(RemoveMassiveContext);
  const [deleteMassiveHistory] = useDeleteMassiveHistoryMutation();
  const [stopMassive] = useStopMassiveProgressMutation();

  return (
    <>
      <CancelModal
        submitTitle="آره، متوقف بشه"
        desc="آیا جستجوی کلمات انبوه متوقف بشه؟"
        setShow={setShowStopModal}
        show={showStopModal}
        submitFunc={() => {
          let isOk;
          setDelayModal(true);
          stopMassive(pauseTaskId)
            .then(() => {
              isOk = true;
            })
            .catch(err => {
              isOk = false;
              console.error('Error stopping Massive Progress:', err);
            });
          setTimeout(() => {
            setDelayModal(false);
            isOk
              ? successMessage('عملیات کلمات انبوه با موفقیت متوقف شد.')
              : errorMessage('خطا در توقف کلمات انبوه');
          }, 5000);
        }}
        title="توقف کلمات انبوه"
      />
      <Modal show={delayModal} backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Body>
            <div className="d-flex align-items-center gap-2">
              <Spinner />
              درحال توقف جستجو کمی منتظر بمانید...
            </div>
          </Modal.Body>
        </Modal.Header>
      </Modal>

      <CancelModal
        desc={`آیا مطئنید میخواهید تاریخچه کلمات انبوه ${keyword
          ?.map(word => decodeURIComponent(word))
          ?.join(', ')
          ?.slice(0, 20)} را حذف کنید`}
        setShow={setShow}
        show={show}
        submitFunc={() => {
          deleteMassiveHistory(task_id)
            .unwrap()
            .then(({ code }) => {
              if (code) {
                if (code == '200')
                  successMessage('حذف کلمات انبوه با موفقیت انجام شد.');
                else if (code == '403')
                  warningMessage(
                    'در حال جستجو هستی. لطفا صبر کن تا جستجو تمام بشه یا ابتدا جستجو رو متوقف کن'
                  );
                else errorMessage('خطای ناشناخته در حذف کلمات انبوه');
              }
            })
            .catch(err => {
              console.error('Error fetching data:', err);
              errorMessage('در انجام عملیات خطایی رخ داد.');
            });
        }}
        submitTitle="آره، حذف بشه"
        title={'حذف کلمات انبوه '}
      />
      {children}
    </>
  );
};

export default MassiveProviders;
